const tabButtons = document.querySelectorAll(
	'.block-tabs-standard-side-image-tab > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tabs-standard-side-image');

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tabs-standard-side-image');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tabs-standard-side-image-tab > .wp-block-button.active'
		);

		if (activeTabs.length) {
			activeTabs.forEach((activeTab) => {
				if (activeTab !== e.currentTarget.parentElement) {
					activeTab.classList.remove('active');
					activeTab.parentElement.classList.remove('active');
				}
			});
		}

		e.currentTarget.parentElement.classList.add('active');
		e.currentTarget.parentElement.parentElement.classList.add('active');

		const activeContent = tabBlock.querySelector(
			'.block-tabs-standard-side-image-tab.active > .block-content'
		);
		const tallestBlockHeightValue =
			tabBlock.style.getPropertyValue('--contentHeight');
		let tallestBlockHeight = tallestBlockHeightValue;

		tabBlock.style.removeProperty('--contentHeight');

		if (tallestBlockHeight) {
			tallestBlockHeight =
				parseFloat(tallestBlockHeight.replace('rem', '')) * 16;
		} else {
			tallestBlockHeight = 0;
		}

		if (activeContent) {
			tabBlock.style.setProperty(
				'--contentOffset',
				`${(activeContent.offsetHeight - tallestBlockHeight) / 16}rem`
			);
		}

		tabBlock.style.setProperty(
			'--contentHeight',
			`${tallestBlockHeightValue}`
		);

		const selectElement = tabBlock.querySelector(
			'.block-tab__mobile-select'
		);
		const tab = e.currentTarget.closest(
			'.block-tabs-standard-side-image-tab'
		);

		if (tab && tab.hasAttribute('data-index') && selectElement) {
			selectElement.value = tab.getAttribute('data-index');
		}

		setTabUnderline(tabBlock);
	}
};

const mobileSelect = (e) => {
	const tabBlock = e.currentTarget.closest('.block-tabs-standard-side-image');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tabs-standard-side-image-tab > .wp-block-button.active'
		);
		const currentTabButton = tabBlock.querySelector(
			'.block-tabs-standard-side-image-tab[data-index="' +
				e.currentTarget.value +
				'"] > .wp-block-button'
		);

		if (currentTabButton) {
			if (activeTabs.length) {
				activeTabs.forEach((activeTab) => {
					if (activeTab !== e.currentTarget.parentElement) {
						activeTab.classList.remove('active');
						activeTab.parentElement.classList.remove('active');
					}
				});
			}

			currentTabButton.classList.add('active');
			currentTabButton.parentElement.classList.add('active');
		}
	}
};

const setTabHeight = () => {
	if (tabBlocks.length) {
		tabBlocks.forEach((tabBlock) => {
			if (
				tabBlock.classList.contains('is-style-crescent') &&
				tabBlock.previousElementSibling
			) {
				if (
					['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(
						tabBlock.previousElementSibling.tagName
					)
				) {
					tabBlock.previousElementSibling.classList.add(
						'block-tabs-standard-side-image__previous-heading'
					);

					if (
						tabBlock.previousElementSibling
							.previousElementSibling &&
						tabBlock.previousElementSibling.previousElementSibling.classList.contains(
							'acf-block'
						)
					) {
						tabBlock.previousElementSibling.previousElementSibling.classList.add(
							'acf-block--previous'
						);
					}
				} else if (
					tabBlock.previousElementSibling.classList.contains(
						'acf-block'
					)
				) {
					tabBlock.previousElementSibling.classList.add(
						'acf-block--previous'
					);
				}
			}

			const contentBlocks = tabBlock.querySelectorAll('.block-content');
			let tallestBlockHeight = 0;

			tabBlock.style.removeProperty('--marginTop');
			tabBlock.style.removeProperty('--contentHeight');

			if (contentBlocks.length) {
				const activeContent = tabBlock.querySelector(
					'.block-tabs-standard-side-image-tab.active > .block-content'
				);

				contentBlocks.forEach((contentBlock) => {
					if (contentBlock.offsetHeight > tallestBlockHeight) {
						tallestBlockHeight = contentBlock.offsetHeight;
					}
				});

				if (activeContent) {
					tabBlock.style.setProperty(
						'--contentOffset',
						`${
							(activeContent.offsetHeight - tallestBlockHeight) /
							16
						}rem`
					);
				}

				if (tallestBlockHeight > 0) {
					tabBlock.style.setProperty(
						'--contentHeight',
						`${tallestBlockHeight / 16}rem`
					);
				}
			}

			setTabUnderline(tabBlock);
		});
	}
};

const setTabUnderline = (tabBlock) => {
	const activeTab = tabBlock.querySelector(
		'.block-tabs-standard-side-image-tab > .wp-block-button.active'
	);

	if (
		activeTab &&
		activeTab.nextElementSibling &&
		activeTab.nextElementSibling.classList.contains('block-content')
	) {
		tabBlock.style.setProperty(
			'--underlinePosition',
			`${
				(activeTab.getBoundingClientRect().left -
					activeTab.nextElementSibling.getBoundingClientRect().left) /
				16
			}rem`
		);

		tabBlock.style.setProperty(
			'--underlineWidth',
			`${activeTab.offsetWidth - 24}`
		);
	}
};

const initTabs = () => {
	if (tabButtons.length) {
		tabButtons.forEach((tabButton) => {
			tabButton.addEventListener('click', toggleTab);
		});
	}

	if (tabBlocks.length) {
		tabBlocks.forEach((tabBlock) => {
			const tabs = tabBlock.querySelectorAll(
				'.block-tabs-standard-side-image-tab'
			);

			const tabContentElements = tabBlock.querySelectorAll(
				'.block-tabs-standard-side-image__content-col > *:not(.block-tabs-standard-side-image-tab):not(.block-tabs-standard-side-image-tab__figure)'
			);

			if (tabContentElements.length) {
				const tabContentCol = tabBlock.querySelector(
					'.block-tabs-standard-side-image__content-col'
				);
				const contentWrapper = document.createElement('div');

				contentWrapper.classList.add(
					'block-tabs-standard-side-image__content'
				);

				tabContentElements.forEach((tabContentElement) => {
					contentWrapper.appendChild(tabContentElement);
				});

				tabContentCol.appendChild(contentWrapper);
			}

			if (tabs.length) {
				const selectElement = document.createElement('select');
				selectElement.classList.add('block-tab__mobile-select');

				tabs.forEach((tab, index) => {
					const tabButton = tab.querySelector(
						'.block-tabs-standard-side-image-tab > .wp-block-button'
					);

					if (tabButton) {
						const option = document.createElement('option');
						option.value = index;
						option.text = tabButton.textContent;
						selectElement.appendChild(option);
						tab.setAttribute('data-index', index);

						if (index + 1 === tabs.length) {
							selectElement.addEventListener(
								'change',
								mobileSelect
							);
							tab.parentElement.appendChild(selectElement);
						}
					}

					tabButton.classList.add('initialized');

					if (0 === index) {
						tabButton.classList.add('active');
						tabButton.parentElement.classList.add('active');
					}
				});

				tabBlock.style.setProperty('--numberOfTabs', `${tabs.length}`);
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initTabs();
		setTabHeight();
	},
	loaded() {},
	resized() {
		setTabHeight();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
